/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React, { useCallback, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../../SharedModules/Table/tableGrid';
import { NDC_AVAILABILITY_TABLEHEAD } from '../../utils/tableHead';
import { PaperComponent } from '../../../../../SharedModules/utilities/utilities';

const NDCAvailabilityPopup = ({
  ndcDialog,
  onNoClick = () => {},
  onConfirmClick = () => {},
  handleClose = () => {},
}) => {
  const childRef = useRef(null);

  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    params.api.selectAll();
  }, []);

  return (
    <Dialog
      open={ndcDialog.open}
      className="multiGroupDialog custom-dialog-box"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <div style={{ cursor: 'move' }} id="draggable-dialog-title">
        <DialogContent>
          <div className="custom-panel">
            <div className="panel-header">
              <span className="float-left">
                {'Below NDCs does not exists in the system'}
              </span>
              <span className="float-right" role="button" onClick={handleClose}>
                <i class="fa fa-times-circle" aria-hidden="true"></i>
              </span>
              <div className="clearfix"></div>
            </div>
            <div className={'row mt-3'} style={{ margin: '0' }}>
              <div className="table-container col-12 no-border priceLoad mt-2">
                <Grid
                  ref={childRef}
                  noRowPadding={true}
                  onGridReady={onGridReady}
                  rowData={ndcDialog.tableData}
                  suppressRowClickSelection={true}
                  rowSelection={'multiple'}
                  defaultCol={{
                    editable: false,
                    sortable: false,
                    filter: false,
                  }}
                  columnDefs={NDC_AVAILABILITY_TABLEHEAD}
                />
              </div>
              <div className="col-12 mt-2 d-flex justify-content-center">
                <span>Would you like to create the selected NDC's now?</span>
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="btn-wrapper my-3 justify-content-end">
            <Button
              onClick={() => {
                onConfirmClick(
                  ndcDialog.mainData,
                  ndcDialog.tableData,
                  gridApi.getSelectedRows().map((item) => item.ndc)
                );
              }}
              data-testid="masterDataSave"
              className="btn btn-success btn-search mr-2"
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              Yes
            </Button>
            <Button
              onClick={() => {
                onNoClick(ndcDialog.mainData, ndcDialog.tableData);
              }}
              className="btn btn-cancel btn-primary mr-2"
              color="primary"
              autoFocus
            >
              <SVGComponent iconName="Icon-cancel" />
              No
            </Button>
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default NDCAvailabilityPopup;
